import * as React from 'react';
import { Modal } from 'react-inv-forms';
import { withTranslation, WithTranslation } from 'react-i18next';
import withAccessProvider from '../../../hoc/withAccessProvider';
import marksActions from '../../../redux/marks/actions';
import { MarksState, MarksActionTypes } from '../../../redux/marks/types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../../redux/reducers';
import { Select, Popconfirm } from 'antd';

const { Option } = Select;
const { closeEmployeeConfirmModal, confirmEmployeeConfirmModal, setEmployeeConfirmModal } = marksActions;

export interface MapStateToProps {
  /** stan modala wyboru nauczyciela (stan ładowania, otwarcia, błędu) */
  employeeConfirmModal: MarksState['employeeConfirmModal'];
}
export interface MapDispatchToProps {
  /** akcja zamknięcia modala */
  closeEmployeeConfirmModal: () => MarksActionTypes;
  /** akcja potwierdzenia wyboru nauczyciela */
  confirmEmployeeConfirmModal: () => MarksActionTypes;
  /** akcja wyboru nauczyciela */
  setEmployeeConfirmModal: (value: string) => MarksActionTypes;
}
type Props = MapStateToProps & MapDispatchToProps & WithTranslation;

/**
 * Komponent modala wyboru pracownika potwierdzającej tożsamość osoby podpisującej oceny w dziekanacie
 *
 */
export class ChooseEmployeeModal extends React.Component<Props> {
  render(): React.ReactElement {
    const { closeEmployeeConfirmModal, confirmEmployeeConfirmModal, setEmployeeConfirmModal, employeeConfirmModal } = this.props;
    const { opened, list, loading, value } = employeeConfirmModal;
    const cancelWithConfirm = (
      <Popconfirm
        title={this.props.t('SIGN_MARKS_MODAL_ARE_YOU_SURE')}
        okText={this.props.t('YES')}
        cancelText={this.props.t('NO')}
        onConfirm={closeEmployeeConfirmModal}
        overlayClassName='custom_popconfirm'
      >
        <a>{this.props.t('CANCEL')}</a>
      </Popconfirm>
    );
    return (
      <Modal
        visible={opened}
        okText={this.props.t('CONFIRM')}
        okButtonProps={{ disabled: !value }}
        confirmLoading={loading}
        onOk={confirmEmployeeConfirmModal}
        title={this.props.t('EMPLOYEE_CONFIRM__MODAL_TITLE')}
        cancelText={cancelWithConfirm}
        closable={false}
        maskClosable={false}
        destroyOnClose
      >
        <h3>{this.props.t('EMPLOYEE_CONFIRM__MODAL_SELECT_A_EMPLOYEE')}:</h3>
        <Select
          loading={loading}
          placeholder={this.props.t('EMPLOYEE_CONFIRM__MODAL_START_TYPING_PLACEHOLDER')}
          defaultOpen={true}
          onChange={setEmployeeConfirmModal}
          notFoundContent={this.props.t('NO_DATA')}
          dropdownClassName='custom_dropdown'
          className='custom_select'
          value={value ? value : undefined}
          disabled={loading}
          autoFocus
        >
          {list.map(employee => (
            <Option key={employee.pracownikId} value={employee.pracownikId} className='custom_option'>
              {`${employee.imie} ${employee.nazwisko} (${employee.pracownikId})`}
            </Option>
          ))}
        </Select>
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  employeeConfirmModal: state.Marks.employeeConfirmModal,
});

const mapDispatchToProps: MapDispatchToProps = {
  closeEmployeeConfirmModal,
  confirmEmployeeConfirmModal,
  setEmployeeConfirmModal,
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
  withAccessProvider,
)(ChooseEmployeeModal) as React.ComponentType<any>;
